import * as React from 'react';
import RadioGroup from 'components/radio_group';
import './styles.scss';

const PreviewStatusEmbedPosition = require('./position_preview_status_embed.svg');
const PreviewAppPosition = require('./position_preview_app.svg');

const positionOptions = [
  {
    name: 'bottomLeft',
    value: 'bottomLeft',
    label: 'Bottom left',
  },
  {
    name: 'bottomRight',
    value: 'bottomRight',
    label: 'Bottom right',
  },
  {
    name: 'topRight',
    value: 'topRight',
    label: 'Top right',
  },
];

const PositionSetup: React.FC<{
  position: string;
  onChange: (value: string) => void;
}> = ({ position, onChange }) => {
  const positionClassName = position
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .toLowerCase();
  return (
    <div className="position-setup config-display-columns">
      <div className="position-config config-column">
        <h1>Positioning</h1>
        <RadioGroup
          onChange={onChange}
          value={position}
          radioWrapperClass="position-config"
          options={positionOptions}
        />
      </div>
      <div className="position-preview display-column">
        <div className="preview-app-position img-container">
          <img src={PreviewAppPosition} />
          <div
            className={`preview-status-embed-position ${positionClassName} img-container`}
          >
            <img src={PreviewStatusEmbedPosition} />
          </div>
        </div>
        <p className="app-preview-note">
          On mobile devices, the default widget will always appear on the bottom
          of the screen.
        </p>
      </div>
    </div>
  );
};

export default PositionSetup;
